<template lang="pug">
  aside(class="aside-menu" style="overflow-y:scroll")
    // TODO: pass in path as prop to components
    component(:is="correspondingRightbarComponent")
</template>

<script>
import blankDiv from './BlankDiv'

import UrlPattern from 'url-pattern'

export default {
  name: 'app-aside',
  components: {
    'blank-div': blankDiv,
  },
  data() {
    return {
      route: null,
      // defo to blankDiv
      correspondingRightbarComponent: blankDiv,
      // TODO: option for retaining show/hide
      rightbarComponentsByRoute: [
        {
          pattern: '/studio',
          component: 'nl-studio-rightbar', // component resides in @/fragments and already imported from base file
          shownAsDefault: false,
        },
        {
          pattern: '/interactions/live',
          shownAsDefault: false,
        },
        {
          pattern: '/interactions/historical',
          shownAsDefault: false,
        },
        {
          pattern: /\/interactions\/(?:.+)/,
          component: 'interaction-rightbar',
          shownAsDefault: true,
        },
      ],
    }
  },
  methods: {
    // TODO: separate getMatchingRoutePattern as a utility library?
    getMatchingRouteObject(route) {
      // matches from top to bottom (taking the first element)
      let routeObject
      const routeObjects = this.rightbarComponentsByRoute
      for (let r of routeObjects) {
        if (new UrlPattern(r.pattern).match(route)) {
          routeObject = r
          break
        }
      }
      routeObject = routeObject || null
      // console.log({ routeObject })
      return routeObject || null
    },
    changeRightbarComponent(matchedRouteObject, component) {
      // use component if supplied, else use component based on route, else default to a blankDiv
      const componentOfPattern = matchedRouteObject ? matchedRouteObject.component : null
      this.correspondingRightbarComponent = component || componentOfPattern || blankDiv
    },
    displayRightbar(matchedRouteObject) {
      const rightbarShown = document.getElementsByClassName('aside-menu-hidden').length === 0
      // if route exists, use its shownAsDefault, else default to hiding sidebar
      const showRightbar = matchedRouteObject ? matchedRouteObject.shownAsDefault : false
      // show rightbar
      if (!rightbarShown && showRightbar) {
        this.$store.dispatch('setAsideStatus')
      } else if (rightbarShown && !showRightbar) {
      // hide rightbar
        this.$store.dispatch('setAsideStatus')
      }
    },
  },
  mounted() {
    this.route = this.$route.path
    const matchedRouteObject = this.getMatchingRouteObject(this.route)
    this.changeRightbarComponent(matchedRouteObject)
    this.displayRightbar(matchedRouteObject)
  },
  watch: {
    $route (to, from) {
      this.route = to.path
      const matchedRouteObject = this.getMatchingRouteObject(this.route)
      this.changeRightbarComponent(matchedRouteObject)
      this.displayRightbar(matchedRouteObject)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Aside.vue?9c61a718